<template>
  <div>
    <v-dialog v-model="dialog_department" persistent scrollable  max-width="500px" transition="dialog-transition" >
      <v-card style="border-radius:8px">
        <v-card-title primary-title>
          <div class="headline mb-0">{{one_department.id? 'Editando' : 'Novo'}} Departamento</div>
        </v-card-title>
        <v-card-text>
          <div v-if="one_department.parent_name">
            {{one_department.parent_name}} :
          </div>
          <v-form ref='deptForm' lazy>
            <v-text-field v-model="one_department.name" :rules="required" prepend-icon="mdi-information" label="Nome"></v-text-field>
            <v-text-field v-model="one_department.code" :rules="required" prepend-icon="mdi-information" label="Código"></v-text-field>
            
            <!-- <v-radio-group :value="one_department.kind" readonly>
              <v-radio label="Estado" value="state"></v-radio>
              <v-radio label="Meso" value="meso"></v-radio>
              <v-radio label="Micro" value="micro"></v-radio>
              <v-radio label="Cidade" value="city"></v-radio>
            </v-radio-group> -->
          </v-form>

        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text color="error" @click="closeDialog()">Cancelar</v-btn>
          <v-btn text color="success" @click="submitdepartment()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import Api from '@/api/index'
import validations from "@/mixins/validations";

export default {
  name: "DialogEditdepartment",
  mixins: [validations],
  props: {
    one_department: {
      type: Object,
    },
  },
  data() {
    return {
      key: null,
      dialog_department: true,
    }
  },
  methods: {
    submitdepartment(){
      if (this.$refs.deptForm.validate()){
        let ACTION = this.one_department.id? 'update' : 'create'
        let noti = {
          type: 'success',
          msg: 'Feito com sucesso'
        }
        Api.Department[ACTION](this.one_department).then(r => r.data).then(department => {
          this.$emit('done', department)
        }).catch(err=> {
          noti = {
            type: 'error',
            msg: `Erro: ${err}`
          }
        }).finally(()=>{
          // this.addNotification(noti)
        })
      }
    },
    closeDialog(){
      this.$emit('close')
    },
    ...mapActions({
      // addNotification: 'Notification/add'
    }),
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // one_store: state=> state.Store.one_store
    })
  },
  watch: {
    dialog_department(nv,ov) {
      if (nv){
      } else if (nv == false){
        this.closeDialog()
      }
    }
  },
}
</script>

<style scoped>

</style>
